import {MutationTree} from 'vuex';
import {HomeState} from "@/module/home/store/home-state";


export const Mutations: MutationTree<HomeState> = {};
